import React from 'react';
import PropTypes from 'prop-types';
import { X, CircleCheck } from 'lucide-react';

// Base
import Button from '../../../../../base/button';
import Modal from '../../../../../base/modal';

export default class Popup extends React.Component {
  static propTypes = {
    duration: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onSetDuration: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
  }

  render() {
    const { isOpen, duration, onConfirm, onCancel, onSetDuration } = this.props;
    return (
      <Modal {...{
        isOpen,
        onCancel,
        onClose: onCancel,
        className: 'grow pop',
        showX: false,
      }}>
        <div className='absolute top-24 right-24'>
          <Button {...{
            size: 'custom',
            onClick: onCancel,
          }}>
            <X {...{ size: 24 }} />
          </Button>
        </div>
        <div className='padding-left-25 margin-top-24 heading-section margin-bottom-10'>
          <div className='xlg-font line-height-26 heading margin-bottom-15'>Confirm your Plan</div>
          <div className='sm-font sub-heading line-height-24 margin-bottom-24'>No credit card required right now.</div>
        </div>
        <div className='flex'>
          <div className='margin-left-45 inline-block'>
            <div className='width-315'>
              <div className='plan-details'>Plan Details</div>
              <div className='details-table'>
                <div className="table">
                  <div className="cell header left">Number of Seats</div>
                  <div className="cell header">Up to 5 Users</div>
                  <div className="cell left">
                    Full Access to the<br />
                    Platform
                  </div>
                  <div className="cell"><CircleCheck size={24} /></div>
                  <div className="cell left">
                    Unlimited Private<br />
                    Contact Imports
                  </div>
                  <div className="cell"><CircleCheck /></div>
                  <div className="cell left">
                    Access to<br />
                    Consultant Search
                  </div>
                  <div className="cell"><CircleCheck /></div>
                  <div className="cell left">
                    AI-Powered<br />
                    Automation
                  </div>
                  <div className="cell"><CircleCheck /></div>
                  <div className="cell left">
                    Unlimited Messaging<br />
                    and Campaigns
                  </div>
                  <div className="cell"><CircleCheck /></div>
                </div>
              </div>
            </div>
          </div>
          <div className='inline-block plan-description margin-left-45'>
            <div className='plan'>Grow Plan</div>
            {
              duration === 'monthly' &&
              <React.Fragment>
                <div className='price'>
                  $439 /  monthly
                </div>
                <div className='save'>
                  (Save up to 15% with annual payment)
                </div>
                <div className='switch-duration-btn'>
                  <Button {...{
                    text: 'Switch to annual to save 15%',
                    onClick: () => onSetDuration('yearly'),
                    size: 'custom',
                  }} />
                </div>
              </React.Fragment>
            }
            {
              duration === 'yearly' &&
              <React.Fragment>
                <div className='flex vertical-align margin-bottom-15'>
                  <div className='price margin-right-25'>
                    $4,479 /  annually
                  </div>
                  <div className='price-saving'>$5,268/Annually</div>
                </div>
                <div className='save'>
                  (Saves 15% compared to monthly payment)
                </div>

              </React.Fragment>
            }
          </div>
        </div>
        <div className='absolute bottom-24 right-24 flex'>
          <Button {...{
            text: 'Cancel',
            onClick: onCancel,
            size: 'custom',
            className: 'cancel',
          }} />
          <Button {...{
            text: 'Submit',
            block: true,
            className: 'submit',
            onClick: onConfirm,
          }} />
        </div>
      </Modal>
    )
  }
}